import { getProps } from '../../utilities/common';

/**
 * Recognized document types, expand list once more identified.
 */
export const DOCUMENT_TYPES = {
    ADMIN_MSA: 'GreenLight-MSA',
    W4FORM: 'USA-W4',
    W9FORM: 'USA-W9',
    I9FORM: 'USA-I9',
    GL_HANDBOOK: 'GreenLight-Handbook',
    GL_IC_CONTRACT: 'GreenLight-ICAgreement',
    TIMESHEET_TEMPLATE: 'Timesheet-Template',
    CA_LABOR_CODE_SECTIONS: 'CA_LABOR_CODE_SECTIONS'
};

export const CLIENT_DOCTYPES = {
    NDA: 'Client-NDA',
    CLIENT_PIIA: 'clientPIIA',
    CLIENT_ORIENTATION_TRAINING: 'clientOrientationTraining',
    OTHER: 'Other'
};

export const CONTRACTOR_DOCTYPES = {};

export const DOCUMENT_NAMES = {
    'Client-NDA': 'Client NDA',
    'GreenLight-MSA': 'GreenLight Master Service Agreement (MSA)',
    'USA-W4': `Form W-4: Employee’s Withholding Allowance Certificate`,
    'USA-W9': 'Form W-9: Request for Taxpayer Identification Number and Certification',
    'USA-I9': 'Form I-9: Employment Eligibility Verification',
    'GreenLight-Handbook': 'GreenLight Employee Handbook',
    'GreenLight-ICAgreement': 'GreenLight Independent Contractor Agreement',
    'Timesheet-Template': 'Timesheet Template',
    CA_LABOR_CODE_SECTIONS: 'California Labor Code Sections 2870-2872',
    clientPIIA: 'Client PIIA',
    clientOrientationTraining: 'Client Orientation Training',
    Other: 'Other'
};

export function getAdminDocumentTypes() {
    return getProps(DOCUMENT_TYPES);
}

export function getClientDocumentTypes() {
    return getProps(CLIENT_DOCTYPES);
}

export function getContractorDocumentTypes() {
    return getProps(CONTRACTOR_DOCTYPES);
}

export const PERMISSIONS = {
    // permissions object, to be used when client uploads doc.
    CLIENT_UPLOAD: {
        client: {
            owner_ref_id_field: 'admin_id',
            owner_ref_type: 'admin',
            permission: 'READ'
        },
        position: {
            owner_ref_id_field: 'client_id',
            owner_ref_type: 'client',
            permission: 'READ'
        }
    },

    // default client upload permissions settings.
    DEFAULT: {
        client: {
            owner_ref_id_field: 'admin_id',
            owner_ref_type: 'admin',
            permission: 'READ'
        },
        position: {
            owner_ref_id_field: 'client_id',
            owner_ref_type: 'client',
            permission: 'READ'
        }
    }
};

export const IC_DOCUMENTS = {
    goodStanding: {
        id: 'onboardingGoodStanding',
        type: 'goodStanding',
        label: 'Certificate of Good Standing',
        helpText:
            'Upload a state-issued document that shows that your business has met its statutory requirements and is authorized to do business in that state.',
        limit: 1
    },
    incorporation: {
        id: 'onboardingIncorporation',
        type: 'incorporation',
        label: 'Certificate of Incorporation',
        helpText:
            'Upload a certificate of incorporation, or a license to form a corporation issued by a state government or, in some jurisdictions, by a non-governmental entity.',
        limit: 1
    },
    dba: {
        id: 'onboardingDBA',
        type: 'dba',
        label: 'Fictitious Business Name or DBA Statement',
        helpText: 'Upload a Fictitious Business Name or Doing Business As statement.',
        limit: 1
    },
    form1099: {
        id: 'onboarding1099',
        type: 'form1099',
        label: '1099 Forms Received From Clients',
        helpText: 'Upload the most recent 1099s your business has received from former or current clients.',
        limit: 3
    },
    marketing: {
        id: 'onboardingMarketing',
        type: 'marketing',
        label: 'Marketing Materials',
        helpText:
            'Upload one or more marketing documents pertaining to your business, such as a screenshot of your website including URL, your profile on a freelancing platform, etc.',
        limit: 6
    },
    investment: {
        id: 'onboardingInvestment',
        type: 'investment',
        label: 'Proof of Investment',
        helpText: 'Upload documentation proving that your business has invested at least $3000 since inception.',
        limit: 6
    },
    incomeSources: {
        id: 'onboardingIncomeSources',
        type: 'incomeSources',
        label: 'Other Documentation of Business Income',
        helpText: `If you don't have a recent 1099, upload other document(s) proving that your business is receiving income from sources other than this client.`,
        limit: 6
    }
};

export const IC_DOCUMENTS_UK = {
    incorporation: {
        id: 'onboardingIncorporation',
        type: 'incorporation',
        label: 'Certificate of Incorporation',
        helpText: 'Upload a certificate of incorporation for your limited company.',
        limit: 1
    },
    marketing: {
        id: 'onboardingMarketing',
        type: 'marketing',
        label: 'Marketing Materials',
        helpText:
            'Upload one or more marketing documents pertaining to your business, such as a screenshot of your website including URL, your profile on a freelancing platform, etc.',
        limit: 6
    },
    investment: {
        id: 'onboardingInvestment',
        type: 'investment',
        label: 'Proof of Investment',
        helpText: 'Upload documentation proving that your business has invested significant capital since inception.',
        limit: 6
    },
    incomeSources: {
        id: 'onboardingIncomeSources',
        type: 'incomeSources',
        label: 'Other Documentation of Business Income',
        helpText: `Upload one or more invoices, contracts, tax documents, or other proof of billing to additional clients.`,
        limit: 6
    }
};



// WEBPACK FOOTER //
// ./src/components/document/types.jsx